export const users = state => state.users
export const drivers = state => state.users.filter(user => user.role === 'delivery')
export const internalUsers = state => state.users.filter(user => ['admin', 'delivery'].includes(user.role))
